import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { Films, AdSidebar } from "@/pages/Home";
import useLenis from "@/hooks/useLenis";
import api from "@/lib/api";

export default function VideosPage() {
  useLenis();
  const [items, setItems] = useState([]);
  const [ads, setAds] = useState([]);
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/content?type=video").then((r) => setItems(r.data)).catch(() => {});
    api.get("/content?type=ad&visible=true").then((r) => setAds(r.data)).catch(() => {});
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-imi-bg text-imi-text min-h-screen">
      <Header />
      <main className="pt-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-imi-text/50 hover:text-imi-gold transition-colors">
            <ArrowLeft size={16} /> Back home
          </Link>
        </div>
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-8 grid lg:grid-cols-[1fr_320px] gap-10">
          <div>
            {items.length > 0 ? (
              <Films items={items} />
            ) : (
              <div className="py-32 text-center text-imi-text/40">No films yet.</div>
            )}
          </div>
          {ads.length > 0 && (
            <div className="lg:sticky lg:top-28 lg:self-start">
              <AdSidebar items={ads} title="Recommended" />
            </div>
          )}
        </div>
      </main>
      <Footer settings={settings} />
    </div>
  );
}
